module.exports = __webpack_public_path__ + "static/img/zhuangweibianjie.87cd02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhuangweibianjie.png
// module id = /WEu
// module chunks = 1